import React from "react";

import styles from "./MatchSuggestionItem.module.scss";
import SVG from "react-inlinesvg";
import { hourFormatter, shortDateFormatter } from "../utils/fullDateFormatter";
import { MatchFromAPI } from "../interfaces/MatchFromAPI";
import { getSportIcon } from "../utils/icons/getSportIcon";

interface MatchSuggestionItemProps {
  match: MatchFromAPI;
  onClick: () => void;
}

export const MatchSuggestionItem: React.FC<MatchSuggestionItemProps> = ({
  match: { sport, away_player, home_player, id, start_date },
  onClick,
}) => {
  const handleOnClick = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  };
  return (
    <div
      className={styles.MatchSuggestionItem}
      key={away_player + start_date + Date.now()}
      onClick={handleOnClick}
    >
      <span className={styles.match}>
        <SVG src={getSportIcon(sport)} />{" "}
        <p>
          {home_player}
          {away_player && ` - ${away_player}`}
        </p>
      </span>
      <span className={styles.date}>
        <label>{shortDateFormatter(start_date)}</label>
        <label>{hourFormatter(start_date)}</label>
      </span>
    </div>
  );
};
